import { scrollToBottom } from '@/util/scrollToBorder';

import { createNamespacedHelpers } from 'vuex';
import dayjs from 'dayjs';

import ImageModal from '../ImageModal/ImageModal.vue';
import ImagePreview from '../ImagePreview/ImagePreview.vue';
import DateRangePicker from '@/components/shared/DateRangePicker/DateRangePicker.vue';
import ImageService from '@/services/image.service';
import CustomSelectDropdown from '../../../components/shared/CustomSelectDropdown/CustomSelectDropdown.vue';
import { showConfirmSwal } from '@/util/swal';

const authMapper = createNamespacedHelpers('global/auth');
const historyMapper = createNamespacedHelpers('history');
const historyImageMapper = createNamespacedHelpers('history/image');
const imageMapper = createNamespacedHelpers('history/image');
const globalMapper = createNamespacedHelpers('global');
const modelMapper = createNamespacedHelpers('history/model');

const FIRST_INDEX = 0;
const DATE_START = 0;
const DATE_END = 1;
const MAX_LENGTH_OF_NAME = 50;

export default {
	name: 'HistoryIndex',

	components: {
		ImageModal,
		ImagePreview,
		DateRangePicker,
		CustomSelectDropdown,
	},

	data() {
		return {
			selectedType: 1,
			selectedModel: '',
			selectedImage: {},
			modalId: 'historyImageModal',
			fields: [
				{
					key: 'created_at',
					sortable: true,
					label: this.$t('detectedDate'),
				},
				{
					key: 'image_name',
					sortable: true,
					label: this.$t('imageName'),
				},
				{
					key: 'class',
					sortable: true,
					label: this.$t('status'),
				},
				{
					key: 'action',
					label: '',
				},
			],
			showOption: '',
			currentPage: 1,
			perPage: 20,
			searchResults: [],
		};
	},

	filters: {
		sortName(name) {
			if (name?.length < MAX_LENGTH_OF_NAME) return name;
			return name.slice(0, MAX_LENGTH_OF_NAME) + '....' + name.split('.').pop();
		},

		localDateString(date) {
			if (date.includes('+') || date.includes('Z')) {
				return dayjs(date).format('YYYY/MM/DD HH:mm:ss');
			}
			return dayjs(date + 'Z').format('YYYY/MM/DD HH:mm:ss');
		},

		status(s) {
			return s === '0' ? 'OK' : 'NG';
		},
	},

	props: {
		historyImageModalId: {
			type: String,
		},

		isRetrieveImages: {
			type: Boolean,
			default: true,
		},

		hideFilter: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...modelMapper.mapState(['models', 'trainable']),
		...authMapper.mapState(['username']),
		...imageMapper.mapState([
			'images',
			'noImage',
			'originImages',
			'allImagesCount',
			'skip',
			'dateStart',
			'dateEnd',
			'imageList',
			'isDisplayList',
		]),
		...historyMapper.mapState(['noCheckBox']),

		isStopRetrieImageByScroll() {
			return this.images.length >= this.allImagesCount;
		},

		filterOptions() {
			return [
				{
					id: 1,
					sortType: this.$t('all'),
				},
				{
					id: 3,
					sortType: this.$t('filterOk'),
				},
				{
					id: 4,
					sortType: this.$t('filterNg'),
				},
			];
		},
	},

	watch: {
		selectedType(newSelected) {
			this.currentPage = 1;
			switch (newSelected) {
				case 1:
					this.SET_IMAGES(this.searchResults);
					break;
				case 3:
					this.onFilterImagesByResult(0);
					break;
				case 4:
					this.onFilterImagesByResult(1);
					break;

				default:
					break;
			}
		},

		models(models) {
			console.log('THIS MODEL', this.model);
			this.selectedModel = models[FIRST_INDEX]?.model_name;
		},

		selectedModel(selectedModel) {
			this.currentPage = 1;
			this.selectedModel = selectedModel;
			this.setModel({ model: selectedModel });
			this.SET_TRAINABLE(selectedModel);
		},

		// searchResults(newVal) {
		// 	if ((newVal.length = 0)) {
		// 		this.SET_NO_IMAGE(true);
		// 	}
		// },
	},

	methods: {
		...globalMapper.mapActions(['setSpinner']),
		...imageMapper.mapActions([
			'retrieveAllImages',
			'getImagesPaginated',
			'sortImageByDate',
			'sortImageByDateRevert',
			'filterImageByResultOK',
			'filterImageByResultNG',
		]),
		...modelMapper.mapActions(['retrieveModels', 'setModel']),
		...modelMapper.mapMutations(['SET_TRAINABLE']),
		...historyMapper.mapMutations(['UPDATE_NO_CHECKBOX']),
		...historyImageMapper.mapMutations([
			'SET_DATE_START',
			'SET_DATE_END',
			'SET_IMAGES',
			'SET_NO_IMAGE',
			'SET_SELECT_FILTER',
			'SET_LIST_ID_RETRAIN',
			'SET_REMOVE_LIST_RETRAIN',
			'SET_IS_DISPLAY_LIST',
		]),
		...historyImageMapper.mapActions(['setIsTraning']),

		onClickRetrainOption(id) {
			this.setIsTraning({
				id,
				isRetraining: true,
			});
			this.SET_LIST_ID_RETRAIN({ id, isRetraining: true });
		},

		onClickUnretrainOption(id) {
			this.setIsTraning({
				id,
				isRetraining: false,
			});
			this.SET_REMOVE_LIST_RETRAIN(id);
		},

		onDeleteImgDetect(id) {
			const confirm = async () => {
				try {
					await ImageService.deleteImageHistory({
						detected_image_id: id,
					});
					this.searchResults = this.searchResults.filter(
						(image) => image['_id']['$oid'] !== id
					);

					switch (this.selectedType) {
						case 1:
							this.SET_IMAGES(this.searchResults);
							break;
						case 3:
							this.onFilterImagesByResult(0);
							break;
						case 4:
							this.onFilterImagesByResult(1);
							break;

						default:
							break;
					}
				} catch (error) {
					console.log(error);
				}
			};
			const dismiss = () => {};
			showConfirmSwal(
				{
					text: this.$t('confirmDeleteImage'),
					yesButton: this.$t('confirmYes'),
					noButton: this.$t('confirmNo'),
				},
				confirm,
				dismiss
			);
		},

		/**
		 * image click event handler
		 * @param {Object} imageData : choosen image's info
		 */
		onClickImage(imageData) {
			console.log('GANG GANG GANG');
			this.selectedImage = imageData;
			this.$bvModal.show(this.historyImageModalId);
		},

		onFilterImagesByResult(result) {
			const resultImages = [...this.searchResults];
			const filteredImages = resultImages.filter(function (item) {
				if (item.show_image === true) return parseInt(item.class) === result;
			});
			this.SET_IMAGES(filteredImages);
		},

		async onSearch() {
			this.setSpinner(true);
			await this.retrieveAllImages({
				username: this.username,
				modelName: this.selectedModel,
				dateStart: this.dateStart,
				dateEnd: this.dateEnd,
			});
			this.setSpinner(false);
			this.searchResults = this.images;
		},

		/**
		 * filter date and time
		 * @param {Object} rangeDate: range date
		 */
		async onFilterDate(rangeDate) {
			this.currentPage = 1;
			const dateStart = dayjs(`${rangeDate[DATE_START]}`).format('YYYY/MM/DD');
			const dateEnd = dayjs(`${rangeDate[DATE_END]}`).format('YYYY/MM/DD');
			this.SET_DATE_START(dateStart + ' 00:00:00');
			this.SET_DATE_END(dateEnd + ' 23:59:59');
		},

		eventBusListeners() {
			this.$eventBus.$on('force-update', () => {
				this.$forceUpdate();
			});
		},

		onSelectDropdown(model) {
			this.selectedModel = model;
		},
	},

	async mounted() {
		this.SET_NO_IMAGE(true);
		this.eventBusListeners();
		// this.handleScroll();

		if (this.originImages?.length && !this.isRetrieveImages) return;
		this.setSpinner(true);
		// Avoid infinity spinner when failed to call API
		try {
			await this.retrieveModels({ username: this.username });
			this.setSpinner(false);
		} catch (error) {
			this.setSpinner(false);
			throw error;
		}
	},
};
